<template>
  <div>
    <v-toolbar
      flat
      class="elevation-1"
    >
      <v-toolbar-title>{{ titulo }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        class="white--text"
        round
        color="primary"
        @click="accionEnItem(null,'imprimirSeleccion')"
      >
        <v-icon
          dark
          small
          class="mr-2"
        >print</v-icon>
        Imprimir selección
      </v-btn>
      <!--v-btn
        class="white--text"
        round
        color="primary"
        @click="accionEnItem(null,'imprimirTodos')"
      >
        <v-icon
          dark
          small
          class="mr-2"
        >print</v-icon>
        Imprimir todos
      </v-btn-->
      <v-btn
        flat
        icon
        small
        @click="mostrarFiltros()"
      >
        <v-icon class="primary--text">filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <filtros
      v-bind:filtros="filtros"
      v-bind:referencia="referenciaFiltros"
      v-bind:combos="combos"
      v-on:alFiltrar="alFiltrar"
    ></filtros>
    <v-data-table
      v-model="itemsSeleccionados"
      select-all
      must-sort
      :headers="headers"
      :items="items"
      :pagination.sync="paginacion"
      :total-items="totalItems"
      :rows-per-page-items="itemsPorPagina"
      :loading="cargando"
      class="elevation-1"
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
        v-if="cargando"
      ></v-progress-linear>
      <template v-slot:items="props">

        <td>
          <v-checkbox
            v-model="props.selected"
            primary
            hide-details
          >
          </v-checkbox>
        </td>
        <td class="text-xs-left pa1">{{ props.item.numero }}</td>
        <td class="text-xs-left pa1">{{ props.item.fecha | formatoFecha }}</td>
        <td class="text-xs-left pa1">{{ props.item.tipo }}</td>
        <td class="text-xs-left pa1">{{ props.item.leyenda }}</td>
        <td class="text-xs-right pa1">{{ props.item.importe | currency }}</td>
        <td class="text-xs-right pa1">{{ props.item.importe_parcial | currency }}</td>
        <td class="text-xs-left pa1">{{ props.item.orden_proyecto_pago_id }}</td>

        <td class="justify-end layout">
          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-1"
            @click="accionEnItem(props.item, 'imprimirItem')"
          >
            <v-icon small>print</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import EventBus from '@/helpers/eventBus'
import filtros from './RetencionListadoFiltros'
import abmListadoMixin from '@/mixins/abmListado'

// import _ from 'lodash'
export default {
  name: 'RetencionListado',
  mixins: [abmListadoMixin],
  components: {
    filtros
  },
  props: {
    combos: {
      type: Object,
      required: true
    }
  },
  computed: {
    referenciaFiltros () {
      return this.referencia
    }
  },
  data: () => ({
    titulo: 'RETENCIONES EXTERNAS',
    headers: [
      { text: 'Nro.', value: 'numero', sortable: false },
      { text: 'Fecha', value: 'fecha', sortable: true },
      { text: 'Tipo', value: 'tipo', sortable: false },
      { text: 'Leyenda', value: 'leyenda', sortable: false },
      { text: 'Importe', value: 'importe', sortable: false, align: 'right' },
      { text: 'Importe Aplicado', value: 'importe_parcial', sortable: false, align: 'right' },
      { text: 'Nro. Orden', value: 'orden_proyecto_pago_id', sortable: false },
      { text: 'Acciones', value: 'id', sortable: false, align: 'right' }
    ],
    paginacion: { descending: true, sortBy: 'fecha' },
    itemsSeleccionados: []
  }),
  mounted () {
  },
  methods: {
    metodoFiltrar (filtros) {
      let vm = this
      return vm.modeloApi.filtrar(filtros)
    },

    accionEnItem (item, accion) {
      switch (accion) {
        case 'imprimirItem':
          this.$emit('accion', accion, item)
          break
        case 'imprimirTodos':
          this.$emit('accion', accion, this.filtros)
          break
        case 'imprimirSeleccion':
          this.$emit('accion', accion, this.itemsSeleccionados)
          break
      }
    },
    mostrarFiltros () {
      EventBus.$emit(this.referenciaFiltros + ':abrir')
    },
    alFiltrar (filtros) {
      this.filtros = filtros

      this.filtrar()
    }

  }
}
</script>

<style lang="scss" scoped></style>
